var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6649 31.7297V45.063C36.6649 46.904 38.1573 48.3964 39.9982 48.3964C41.8392 48.3964 43.3315 46.904 43.3315 45.063V31.7297C43.3315 29.8887 41.8392 28.3964 39.9982 28.3964C38.1573 28.3964 36.6649 29.8887 36.6649 31.7297Z",
    fill: "#E00060"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3552 57.42C43.657 56.1183 43.657 54.0078 42.3552 52.706C41.0535 51.4043 38.9429 51.4043 37.6412 52.706C36.3394 54.0078 36.3394 56.1183 37.6412 57.42C38.9429 58.7218 41.0535 58.7218 42.3552 57.42Z",
    fill: "#E00060"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2301 13.8538L8.52635 55.2547C4.87175 61.919 9.69393 70.063 17.2945 70.063H62.7019C70.3025 70.063 75.1246 61.919 71.4701 55.2547L48.7663 13.8538C44.9703 6.93154 35.0261 6.93156 31.2301 13.8538ZM14.3718 58.4603L37.0755 17.0593C38.3409 14.7519 41.6556 14.7519 42.9209 17.0593L65.6246 58.4603C66.8428 60.6817 65.2355 63.3964 62.7019 63.3964H17.2945C14.761 63.3964 13.1536 60.6817 14.3718 58.4603Z",
    fill: "#E00060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/iconWarning.68e0d46ac5f8a4082e0b8db3366da06e.svg";
export { ForwardRef as ReactComponent };